import { memo } from "react";
import PropTypes from 'prop-types';
import BzButton from "./BzButton";

const BzToggleButton = ({ wrapperClassName, leftButtonClassName, rightButtonClassName, leftButtonTitle, rightButtonTitle, setActiveButtonToggleIndex, isDisabled, ...props }) => {
    const handlePresssKey = (e) => {
        if (e?.target?.id === 'buyButton' && e?.key === 'ArrowRight') {
            const sellButton = document.getElementById('sellButton');
            sellButton?.focus();
        } else
            if (e?.target?.id === 'sellButton' && e?.key === 'ArrowLeft') {
                const buyButton = document.getElementById('buyButton');
                buyButton?.focus();
            }
    };

    return (
        <div className={wrapperClassName}>
            <BzButton id='buyButton' onKeyDown={handlePresssKey} disabled={isDisabled} className={leftButtonClassName} onClick={() => setActiveButtonToggleIndex(0)}>{leftButtonTitle}</BzButton>
            <BzButton id='sellButton' onKeyDown={handlePresssKey} disabled={isDisabled} className={rightButtonClassName} onClick={() => setActiveButtonToggleIndex(1)}>{rightButtonTitle}</BzButton>
        </div>
    );
};

BzToggleButton.propTypes = {
    leftButtonTitle: PropTypes.string.isRequired,
    rightButtonTitle: PropTypes.string.isRequired,
    activeButtonToggleIndex: PropTypes.number.isRequired,
    setActiveButtonToggleIndex: PropTypes.func.isRequired,
    wrapperClassName: PropTypes.string,
    leftButtonClassName: PropTypes.string,
    rightButtonClassName: PropTypes.string,
    isDisabled: PropTypes.bool
};

BzToggleButton.defaultProps = {
    leftButtonTitle: '',
    rightButtonTitle: '',
    activeButtonToggleIndex: 0,
    wrapperClassName: '',
    leftButtonClassName: '',
    rightButtonClassName: '',
    isDisabled: false,
};

export default memo(BzToggleButton)

